import { z } from 'zod';
import { THEMES } from '../constants/themes.js';
export const updateProfileSchema = z.object({
    email: z.string().email('Invalid email address').optional(),
    displayName: z.string().min(1, 'Display name is required').max(100).optional(),
}).refine((data) => data.email !== undefined || data.displayName !== undefined, {
    message: 'At least one field must be provided',
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password must not exceed 128 characters'),
});
export const userPreferencesSchema = z.object({
    theme: z.enum(THEMES).optional(),
    defaultView: z.enum(['grid', 'table']).optional(),
    itemsPerPage: z.union([z.literal(10), z.literal(20), z.literal(50)]).optional(),
    showTicker: z.boolean().optional(),
    betaUi: z.boolean().optional(),
});
//# sourceMappingURL=profile.js.map